import { setOptions, importLibrary } from "@googlemaps/js-api-loader";

let configured = false;
let loadPromise = null;

const IBIZA_BOUNDS = {
  north: 39.12,
  south: 38.82,
  east: 1.64,
  west: 1.20,
};

const IBIZA_CENTER = { lat: 38.973, lng: 1.432 };

function ensureConfigured() {
  if (configured) return;
  setOptions({
    key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    v: "weekly",
    language: "es",
    region: "ES",
  });
  configured = true;
}

export function loadGoogleMaps() {
  if (!loadPromise) {
    ensureConfigured();
    loadPromise = Promise.all([
      importLibrary("maps"),
      importLibrary("places"),
      importLibrary("routes"),
    ]).then(() => window.google);
  }
  return loadPromise;
}

export function kmToZone(km, zones) {
  // Find price for a given zone id from the provided zones array (fallback to defaults)
  const priceFor = (id) => {
    if (Array.isArray(zones)) {
      const z = zones.find((x) => String(x.id) === String(id));
      if (z && typeof z.price === "number") return z.price;
    }
    return { "1": 45, "2": 55, "3": 65, "4": 80 }[id] ?? 45;
  };
  if (km <= 10) return { id: "1", price: priceFor("1") };
  if (km <= 15) return { id: "2", price: priceFor("2") };
  if (km <= 25) return { id: "3", price: priceFor("3") };
  return { id: "4", price: priceFor("4") };
}

export { IBIZA_BOUNDS, IBIZA_CENTER };
